<template>
  <div class="shadow-fixed show">
    <div class="mask"></div>
    <div class="vfDetails-box" :style="getBoxHeight()">
      <div class="vfDetails-small-close" @click="$emit('closeVfDetails')"></div>
      <div class="vfDetails-scroll-box">
        <div
          class="vfDetails-inner"
          v-for="status in vfDetailsObj.FlowStatus"
          :key="status"
          :style="status == 2 || status == 5 ? {marginBottom:'30px'} : ''"
        >
          <div class="circle"></div>
          <div class="line" v-if="status < vfDetailsObj.FlowStatus" :style="getLineHeight(status)"></div>
          <div class="vfDetails-content">
            <p class="content-title">{{status | statusText1(vfDetailsObj.Title)}}</p>
            <p class="content-code" v-if="status==1">签证流单号：{{vfDetailsObj.FlowCode}}</p>
            <p
              class="content-date"
              :style="status == 1 || status == 3 || status == 6 ? {marginBottom:'20px'} : ''"
            >{{vfDetailsObj.FlowTime[0]}}</p>
          </div>
          <div class="vfDetails-pic">
            <img
              :src="item"
              alt
              v-for="(item,index) in (
              status == 1 ? vfDetailsObj.OrderImgs.split(',') : 
              status == 3 ? vfDetailsObj.QuoteImgs.split(',') :
              status == 6 ? vfDetailsObj.VerifyImgs.split(',') : ''
              )"
              :key="item"
              @click="showLargePic(status,index)"
            />
          </div>
        </div>
        <div class="vfDetails-btn" v-if="vfDetailsObj.FlowStatus < 6" @click="update">
          <span>{{vfDetailsObj.FlowStatus | statusText2}}</span>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import "../../../../../html/components/d-vfDetails/d-vfDetails.scss"

import { UpdateVisaflow } from '../../../../../api/index'


export default {
  name: 'd-vfDetails',
  data() {
    return {
    }
  },
  props: {
    vfDetailsObj: {
      type: Object,
      required: true
    },
    IsLogin: {
      type: Boolean,
    },
    CanOperat: {
      type: Boolean
    },
    id: {
      type: Number
    }
  },
  components: {
  },
  methods: {
    getLineHeight(status) {
      let height;
      if (status == 1) {
        height = 150 + Math.ceil((this.vfDetailsObj.OrderImgs.split(',').length) / 4) * 200 + 'px';
      } else if (status == 3) {
        height = 110 + Math.ceil((this.vfDetailsObj.QuoteImgs.split(',').length) / 4) * 200 + 'px';
      }
      return { height }
    },
    getBoxHeight() {
      let height;
      if (this.vfDetailsObj.FlowStatus == 1 && this.vfDetailsObj.OrderImgs.split(',').length / 4 < 1) {
        height = "550px";
      } else {
        height = "800px";
      }
      return { height }
    },
    showLargePic(status, activeIndex) {
      if (status == 1) {
        this.$emit('showLargePic', this.vfDetailsObj.OrderImgs, activeIndex)
      } else if (status == 3) {
        this.$emit('showLargePic', this.vfDetailsObj.QuoteImgs, activeIndex)
      } else if (status == 6) {
        this.$emit('showLargePic', this.vfDetailsObj.VerifyImgs, activeIndex)
      }
    },
    async update() {
      if (!this.IsLogin) {
        this.$layer.alert('您还未登录，请登录', (layerid) => {
          this.$layer.close(layerid);
          this.$login.show(1, userInfo => {
            this.setUserInfo(userInfo);
          });
        })
      } else if (!this.CanOperat) {
        this.$layer.alert('您没有权限审核');
      } else {
        if (
          this.vfDetailsObj.FlowStatus == 1 ||
          this.vfDetailsObj.FlowStatus == 3 ||
          this.vfDetailsObj.FlowStatus == 4
        ) {
          let res = await UpdateVisaflow({
            id: this.id,
            FlowStatus: this.vfDetailsObj.FlowStatus + 1,
            ImgPaths: ''
          });
          // console.log(res);
          if (res.Type == "Success") {
            this.$layer.alert('修改成功', (layerid) => {
              this.$layer.close(layerid);
              this.$emit('showVfDetails');
            })
          }
        }else if(
          this.vfDetailsObj.FlowStatus == 2 ||
          this.vfDetailsObj.FlowStatus == 5 
        ){
          this.$emit('update')
        }
      }
    }
  },
  filters: {
    statusText1(status, val) {
      switch (status) {
        case 1:
          return val;
        case 2:
          return "负责人确认";
        case 3:
          return "设计部已完成报价";
        case 4:
          return "成本部已完成审核";
        case 5:
          return "负责人确认完毕";
        case 6:
          return "流程已完成";
      }
    },
    statusText2(status) {
      switch (status) {
        case 1:
          return "通过审核";
        case 2:
          return "通过审核";
        case 3:
          return "通过审核";
        case 4:
          return "确定";
        case 5:
          return "上传甲方确认单";
      }
    }
  },
  created() {
  }
}
</script>